import React from "react";

const ReadMoreNyrstar = () => {
  return (
    <div>
      <div>
        <p className="mb-2">
        To discuss the industrial dimension of our project, we conducted an interview with Louis Nel, Global Head of Health 
        and Safety for Nyrstar. Nyrstar is an international producer of critical minerals and metals essential for a low 
        carbon future. With a market leading position in zinc and lead, Nyrstar has mining, smelting and other operations 
        located in Europe, the United States and Australia and employs approximately 4,000 people. Its Corporate Office is 
        based in Budel-Dorplein, the Netherlands.
        </p>
      <p className="mb-2">
        During this interview our project was presented, and questions were asked to assess the potential impact thereof on 
        Nyrstar employees and nearby communities. The initial question focused on whether Nyrstar faced any issues with cadmium 
        and whether our probiotic could be considered a safety measure upon approval.
        </p>
      <p className="mb-2">
        Louis Nel acknowledged the significant care is taken around emissions in various industries, emphasizing its importance 
        for both employees and neighbouring communities. He mentioned that Nyrstar is diligent in its efforts to be a 
        responsible producer and considers the environmental, social and governance aspects for all the business decisions 
        that are made. Regarding cadmium, he expressed that the company conducts regular monitoring of industrial hygiene and 
        employee health, including cadmium testing. He indicated an interest in considering solutions to further prevent heavy 
        metal absorption, not just for Nyrstar but for the broader industry. “For cadmium we haven't had serious exposure or 
        health impacts on employees, but it's not to say that this is not something that we would not consider in the longer 
        term because there is still an exposure and there are indications that people can contract some of these heavy metals. 
        If there's anything to help them, to support us in the future to prevent these metals from being absorbed into the body
        we would certainly be interested to look at it and to see how this could benefit not just Nyrstar but a much wider 
        industry. So if we know there is an additional control that we can use and something that has evidently proven to 
        absorb the heavy metals before it actually gets taken up by the body and you can safely expel it from the body, then 
        I believe it's to be a very viable project to look into for the industry.”
        </p>
      <p className="mb-2">
        When asked how the probiotic could be implemented if approved, Nel highlighted the possible challenge of promoting 
        its use to the workforce, however, he believed that if properly communicated, it could be a valuable addition to 
        Nyrstar's health and safety measures. “Personally, I think if you approach and raise awareness on the benefits and the 
        people understand what it can do for them, in addition to what we are already doing for the employees, that would be 
        an added advantage to our health and safety controls. So yes, personally as I can't speak for all of industry, I 
        think this is a fantastic improvement in technology to show what more we can do to protect the population that may 
        be exposed to these heavy metals. So yes, I am certainly interested.”
        The awareness of heavy metals among the workforce and nearby populations was discussed, with Nel stating that Nyrstar 
        maintains transparency at all times and consistently reminds people of the potential risks in the workplace.
        </p>
      <p className="mb-2">
        In conclusion, Nel expressed interest in our project and its potential benefits for the industry. The interview 
        highlighted the importance of transparent communication and effective promotion of the probiotic's benefits, 
        focusing mainly on cadmium as the primary metals of concern
        </p>
        <br></br>
        <p> *Approved version from Nyrstar Global Head of Corporate Affairs & Communications team </p>


      </div>
    </div>
  );
};

export default ReadMoreNyrstar;
